import { render, staticRenderFns } from "./ComparisonResults.vue?vue&type=template&id=97dd2916&"
import script from "./ComparisonResults.vue?vue&type=script&lang=js&"
export * from "./ComparisonResults.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonResults.vue?vue&type=style&index=0&id=97dd2916&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports